import { Injectable, Inject } from '@angular/core';
import {environment} from '../../../environments/environment';
import { WINDOW } from 'app/window.providers';

@Injectable()
export class SampleService {
  constructor(@Inject(WINDOW) private window: Window) {}

  getHostname(): string {
    return this.window.location.hostname;
  }
  clientId;
  getClientId(): string {
    let hostName = this.getHostname();
    console.log('hostName :', hostName);
    for (let i = 0; i < environment.clients.length; i++) {
      if (hostName === environment.clients[i].url) {
        this.clientId = environment.clients[i].kc;
        environment.urlAPIBookbeds = environment.clients[i].urlAPIBookbeds;
      }
    }
    return this.clientId;
  }
}
